import { emptyGuid } from "@insite/client-framework/Common/StringHelpers";
import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";
import {
    GetCategoriesApiParameter,
    getCategoryNavigationTree,
    GetCategoryNavigationTreeResult,
} from "@insite/client-framework/Services/CategoryService";

type Props = {
    rootId: string;
    apiParameter: GetCategoriesApiParameter;
    apiResult: GetCategoryNavigationTreeResult;
};

type HandlerType = Handler<GetCategoriesApiParameter, Props>;

export const PopulateRootId: HandlerType = props => {
    props.rootId = props.parameter.startCategoryId ?? emptyGuid;
};

export const CheckIfLoading: HandlerType = props => {
    if (props.getState().data.navigationTree.isLoadingByRootId[props.rootId]) {
        return false;
    }
};

export const DispatchBeginLoad: HandlerType = props => {
    props.dispatch({
        type: "Data/NavigationTree/BeginLoad",
        rootId: props.rootId,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getCategoryNavigationTree(props.apiParameter);
    } catch (error) {
        if (error?.status === 404 || error?.status === 403) {
            props.dispatch({
                type: "Data/NavigationTree/FailedToLoad",
                rootId: props.rootId,
                status: error.status,
            });
            return false;
        }
        throw error;
    }
};

export const DispatchCompleteLoad: HandlerType = props => {
    props.dispatch({
        type: "Data/NavigationTree/CompleteLoad",
        result: props.apiResult,
    });
};

export const chain = [
    PopulateRootId,
    CheckIfLoading,
    DispatchBeginLoad,
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchCompleteLoad,
];

const loadNavigationTree = createHandlerChainRunnerOptionalParameter(chain, {}, "LoadNavigationTree");
export default loadNavigationTree;
